module.exports = __webpack_public_path__ + "img/kh2_44.096a04ad.png";